/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Akshay's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Akshay Sharma Portfolio",
    type: "website",
    url: "https://akshaysharma7.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Akshay Sharma",
  logo_name: "Aks\0h\0a\0y Sh\0arm\0a",
  /*nickname: "layman_brother",*/
  subTitle:
    "A passionate individual who thrives to work with trending technologies to develop end-to-end product(s)/solution(s) inorder to establish impact on the end stake holders and consumers.",
  resumeLink:
    "https://drive.google.com/file/d/1HEId4APhqHRfkvrIMhoapigTfQTNwPHV/view?usp=sharing",
  portfolio_repository: "https://github.com/AkshaySharma7/masterPortfolio",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/AkshaySharma7",
  // linkedin: "https://www.linkedin.com/in/mr-akshay-sharma/",
  // gmail: "mr.akshaysharma7@gmail.com",
  // facebook: "https://www.facebook.com/mr.akshaysharma7/",
  // twitter: "https://twitter.com/Akshay_Sharma7",
  // instagram: "https://www.instagram.com/mr.akshaysharma/"

  {
    name: "Github",
    link: "https://github.com/AkshaySharma7",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mr-akshay-sharma/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  /*{
    name: "YouTube",
    link: "https://www.youtube.com/channel/UC_amoXmmxSY9KusoDczDTXQ",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },*/
  {
    name: "Gmail",
    link: "mailto:mr.akshaysharma7@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/Akshay_Sharma7",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/mr.akshaysharma7/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/mr.akshaysharma/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Big data processing, visualizing and reporting",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pandas",
          /*logo_path:"neo4j_icon_square.png",*/
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos:numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Neo4j",
          fontAwesomeClassname: "logos:neo4j",
          style: {
            backgroundColor: "transparent",
          },
        },
        /*{
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },*/
        {
          skillName: "Tableau",
          fontAwesomeClassname: "logos:tableau-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Power BI",
          fontAwesomeClassname: "simple-icons:powerbi",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Grafana",
          fontAwesomeClassname: "logos:grafana",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Apache Spark",
          fontAwesomeClassname: "cib:apache-spark",
          style: {
            backgroundColor: "#E25A1C",
            color: "#ffffff"
          },
        },
        /*{
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },*/
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front end using HTML, AngularJS, Angular Material, CSS, TypeScript, JavaScript, and React.",
        "⚡ Developing REST API using Java and Jersey RESTful web services"
      ],
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
          },
        },

        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "vscode-icons:file-type-typescript-official",
          style: {
            backgroundColor: "tranparent",
          },
        },
        {
          skillName: "AngularJS",
          fontAwesomeClassname: "ri:angularjs-fill",
          style: {
            color: "#DD0031",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "XML",
          fontAwesomeClassname: "carbon:xml",
          style: {
            color: "#DD0031",
            backgroundColor: "white",
          },
        },
        {
          skillName: "Jersey RESTful API",
          fontAwesomeClassname: "mdi:api",
          style: {
            color: "#FF6600",
            backgroundColor: "white",
          },
        },
        {
          skillName: "JSON",
          fontAwesomeClassname: "logos:json",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Apache Maven",
          fontAwesomeClassname: "vscode-icons:file-type-maven",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Data Bases",
      fileName: "DatabaseImg",
      skills: [
        "⚡ Specilaized in both NoSQL and SQL databases",
        "⚡ Analysing graph nodes for AI & ML using Neo4j"
      ],
      softwareSkills: [
        {
          skillName: "Neo4j",
          fontAwesomeClassname: "logos:neo4j",
          style: {
            backgroundColor: "#transparent",
          },
        },
        {
          skillName: "Elasticsearch",
          fontAwesomeClassname: "logos:elasticsearch",
          style: {
            backgroundColor: "#transparent",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos:mysql",
          style: {
            backgroundColor: "#transparent",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining TEST and PROD environments on virtual machine instances along with integration of databases",
        "⚡ Configuring end-to-end DevOps pipeline on AWS instance."
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "simple-icons:jirasoftware",
          style: {
            color: "#ffffff",
            backgroundColor: "#0052CC",
          },
        },
        {
          skillName: "RabbitMQ",
          fontAwesomeClassname: "logos:rabbitmq-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "akar-icons:github-fill",
          style: {
            color: "#181717",
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Bitbucket",
          fontAwesomeClassname: "logos:bitbucket",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "logos:jenkins",
          style: {
            backgroundColor: "transparent",
          },
        },
        /*{
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },*/
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Ansible",
          fontAwesomeClassname: "logos:ansible",
          style: {
            backgroundColor: "transparent",
          },
        },
        /*{
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },*/
      ],
    },
    {
      title: "Utilities",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Documenting product catalogue on Confluence",
        "⚡ Creating reports and presentations using MS Office, Excel, Powerpoint and Keynote.",
      ],
      softwareSkills: [
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "logos:jupyter",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "PyCharm",
          fontAwesomeClassname: "logos:pycharm",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "Confluence",
          fontAwesomeClassname: "logos:confluence",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "Eclipse",
          fontAwesomeClassname: "logos:eclipse-icon",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "Visual Studio Code",
          fontAwesomeClassname: "logos:visual-studio-code",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "MS Office",
          fontAwesomeClassname: "mdi:microsoft-office",
          style: {
            color: "#ffffff",
            backgroundColor: "#D83B01"
          },
        },
        {
          skillName: "MS Excel",
          fontAwesomeClassname: "vscode-icons:file-type-excel",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "MS PowerPoint",
          fontAwesomeClassname: "vscode-icons:file-type-powerpoint",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "grommet-icons:figma",
          style: {
            //color:"#ffffff",
            backgroundColor: "tranparent"
          },
        },
      ],
    },
    {
      title: "What I Speak?",
      fileName: "LanguagesKnownImg",
      skills: [
        "⚡ Fluent in English and Hindi.",
        "⚡ Intermediate in French.",
        "⚡ My soft skills include Communication, Problem Solving, Collaboration, Creative Thinking, Adaptability, Interpersonal Skills, Logical Reasoning."
      ],
      softwareSkills: [
        {
          skillName: "English",
          fontAwesomeClassname: "ri:english-input",
          style: {
            backgroundColor: "#ffffff",
            color: "#0AC18E"
          },
        },
        {
          skillName: "Hindi",
          fontAwesomeClassname: "uil:letter-hindi-a",
          style: {
            backgroundColor: "#ffffff",
            color: "#1287B1"
          },
        },
        {
          skillName: "French",
          fontAwesomeClassname: "emojione:flag-for-france",
          style: {
            backgroundColor: "#transparent",
          },
        },
        {
          skillName: "Communication Skills",
          fontAwesomeClassname: "noto:speaking-head",
          style: {
            backgroundColor: "#transparent",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/akshaysharma7",
    },
    /*{
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/",
    },*/
    /*{
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },*/
  ],
};

const degrees = {
  degrees: [
    {
      title: "Annamalia University, Chidambaram",
      subtitle: "Post Graduate Diploma in Computer Applications",
      logo_path: "Annamalai_University_logo.png",
      alt_name: "Annamalai Distance Education",
      duration: "2018 - 2019",
      descriptions: [
        "⚡ Percentage (%): 73.91",
        "⚡ Completed the program through distance education.",
        "⚡ Exposure to in depth knowledge of Software and Hardware was given throught the course.",
        "⚡ To organize online appointments of hospitals, designed software during capstone project."
      ],
      website_link: "https://annamalaiuniversity.ac.in/",
    },
    {
      title: "Lovely Professional University, Jalandhar",
      subtitle: "B.Tech. in Computer Science and Engineering",
      logo_path: "lpu-logo.png",
      alt_name: "LPU, Jalandhar",
      duration: "2012 - 2016",
      descriptions: [
        "⚡ CGPA: 7.76",
        "⚡ I received exposure of programming languages such as C, C++, Java, Python, HTML, CSS, SQL, Matlab.",
        "⚡ I have studied fundamentals of software engineering subjects like Data Structures, Algorithms, DBMS, OS, Computer Architecture, AI etc.",
        "⚡ Apart from this, I have involved into extra-curricular activites such as Theatre, Music, University fests, which improved my communication skills.",
        "⚡ Excelled in Software Engineering courses.",
        "⚡ To enhance functionality of Human Resource Management, designed software during capstone project."
      ],
      website_link: "https://www.lpu.in",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Neo4j Certified Professional",
      subtitle: "- Neo4j",
      logo_path: "Neo4j-logo-color.svg",
      certificate_link:
        " https://graphacademy.neo4j.com/certificates/3af7bd3ced4ba0148ccce154d6cac1e9eca7aa8f2aa3b04244a0ee3aef3189fe.pdf",
      alt_name: "Neo4j",
      color_code: "#FFFFFF",
    },
    {
      title: "Tableau 2020 A-Z:Hands-On Tableau Training For Data Science!",
      subtitle: "- Kirill Eremenko",
      logo_path: "udemy-icon.svg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-3c49c14b-ccd9-438b-a5d5-c61fa1129d49/",
      alt_name: "udemy",
      color_code: "#FFFFFF",
    },
    {
      title: "Microsoft Power BI - A Complete Introduction",
      subtitle: "- Manuel Lorenz",
      logo_path: "udemy-icon.svg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-bf86bda4-d077-4b1f-91e0-2d7b310199df/",
      alt_name: "udemy",
      color_code: "#FFFFFF",
    },
    {
      title: "DevOps Project: CI/CD with Jenkins Ansible Docker Kubernetes",
      subtitle: "- Shankar AR",
      logo_path: "udemy-icon.svg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-N00BJRU0/",
      alt_name: "udemy",
      color_code: "#FFFFFF",
    },
    {
      title: "Mastering the Coding Interview: Data Structures + Algorithms",
      subtitle: "- Andrei Neagoie",
      logo_path: "udemy-icon.svg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-RWNP971B/",
      alt_name: "udemy",
      color_code: "#FFFFFF",
    },
    {
      title: "Mastering the Coding Interview: Data Structures + Algorithms",
      subtitle: "- Andrei Neagoie",
      logo_path: "udemy-icon.svg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-RWNP971B/",
      alt_name: "udemy",
      color_code: "#FFFFFF",
    },
    /*{
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },*/
  ],
};

// Experience Page
const experience = {
  title: "Work Experience",
  //subtitle: "Work Expereince",
  description:
    "I am currently working as a Data Analyst with one of the Big 4 companies globally (Client). As Full Stack Developer and Data Analyst, contributed to an open source DevOps metrics software, which can give better insights of DevOps. For my love towards Data Science, AI, and ML, I have been consistently working to keep up with the new technology stack.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Senior Analyst",
          company: "Infosys",
          company_url: "https://www.infosys.com/",
          logo_path: "infosys-technologies-logo.svg",
          duration: "February, 2020 - Present",
          location: "Hyderabad, Telangana",
          description: [
            "⚡ To provide better team/individual metrics insights like performance, quality, productivity, and rejection count, etc,. used Python, Pandas & NumPy to process and compute large set of data from raw data.",
            "⚡ Using the processed data, created dashboards, pivots in Tableau & Microsoft excel, to provide meaningful reports to business owners.",
            "⚡ To eliminate business risks & timely delivery, planned utilisation of resources, manpower to drive business efficiently."],
          color: "#007CC3",
        },
        {
          title: "Associate - Projects",
          company: "Cognizant",
          company_url: "https://www.cognizant.com/",
          logo_path: "cognizant-logo.svg",
          duration: "November, 2016 - February, 2020",
          location: "Hyderabad, Telangana",
          description: [
            "Project Name: OneDevOps – Insights (Open source tool, and patented)",
            "GitHub Address: https://github.com/CognizantOneDevOps/Insights",
            "⚡ For best user experience, designed and built product’s UI in HTML using AngularJS, Angular Material, CSS, TypeScript, and JavaScript.",
            "⚡ To provide REST API services and establish a middleware between the UI and backend, coded the product’s services using Java and Jersey RESTful web services.",
            "⚡ Wrote development test cases for Java using Mockito, and JUnit, resulting in better code coverage.",
            "⚡ To collect data from DevOps implementation tools, wrote Python agents to fetch results using tool’s RESTful API, and then save results into Neo4j database.",
            "⚡ For DevOps trends, monitoring purpose, created dashboards in Grafana using Elasticsearch’s luecene and Neo4j’s cypher queries. Also, to reduce Neo4j DB hits created a query caching mechanism using Java.",
          ],
          color: "#1A4CA1",
        },
        /*{
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          description:
            "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
          color: "#fc1f20",
        },*/
      ],
    },
    /*{
      title: "Internships",
      experiences: [
        {
          title: "Data Science Research Intern",
          company: "Delhivery Pvt. Ltd.",
          company_url: "https://www.delhivery.com/",
          logo_path: "delhivery_logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Gurgaon, Haryana",
          description:
            "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
          color: "#ee3c26",
        },
        {
          title: "Data Science Intern",
          company: "Intel Indexer LLC",
          company_url:
            "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Work From Home",
          description:
            "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Explore ML Facilitator",
          company: "Google",
          company_url: "https://about.google/",
          logo_path: "google_logo.png",
          duration: "June 2019 - April 2020",
          location: "Hyderabad, Telangana",
          description:
            "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
          color: "#4285F4",
        },
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2019 - May 2020",
          location: "Hyderabad, Telangana",
          description:
            "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
          color: "#D83B01",
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "DSC IIITDM Kurnool",
          company_url:
            "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
      ],
    },*/
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact-akshay.svg",
    description:
      "I am available on almost every social media. You can drop me a message; I will reply within 24 hours. I can assist you with Business Intelligence, Data Analysis, Data Science, Full Stack Development, Cloud, and Opensource Development.",
  },
  /*blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://www.wordpress.com",
    avatar_image_path: "blogs_image.svg",
  },*/
  addressSection: {
    title: "Address",
    subtitle:
      "Sainikpuri, Hyderabad 500094.",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/1TxZFp3rbrXrgK9b6",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 8121486369",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
